import React from "react";
import PropTypes from "prop-types";

class EventSearch extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sidebarOpen: false,
    };
  }

  componentDidMount = () => {
    window.toggleEventSearchSidebar = () => {
      this.toggleSidebar();
    };
  };

  openSidebar = () => {
    this.setState({ sidebarOpen: true });
  };

  closeSidebar = () => {
    this.setState({ sidebarOpen: false });
  };

  toggleSidebar = () => {
    const { sidebarOpen } = this.state;

    if (sidebarOpen) {
      this.closeSidebar();
    } else {
      this.openSidebar();
    }
  };

  render = () => {
    const { loading, sidebar, content } = this.props;

    const { sidebarOpen } = this.state;

    return (
      <div className="event-search">
        <div
          className={`event-search__sidebar ${sidebarOpen ? "is-open" : ""}`}
        >
          <button
            className="event-search__sidebar-toggle btn is-default is-block"
            type="button"
            onClick={this.toggleSidebar}
          >
            <svg className="btn__icon is-prefix" width="18" height="18">
              <use xlinkHref="#filter" width="18" height="18" />
            </svg>
            <span className="btn__text">Open filters</span>
          </button>
          <div className="event-search__sidebar-content">{sidebar}</div>
        </div>
        <div className={`event-search__content ${loading ? "is-loading" : ""}`}>
          {content}
        </div>
      </div>
    );
  };
}

EventSearch.propTypes = {
  loading: PropTypes.bool.isRequired,
  sidebar: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
};

export default EventSearch;
